import { createTheme } from "@mui/material/styles";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./SchedulingDesign.css";

export const schedulingTheme = createTheme({
  palette: { primary: { main: "#005da8", dark: "#084b80" }, text: { primary: "#172b3a", secondary: "#627485" }, divider: "#e3e9ee", background: { default: "#f6f8fb", paper: "#fff" } },
  typography: { fontFamily: '"Inter", system-ui, sans-serif', fontSize: 14,
    button: { textTransform: "none", fontWeight: 600, fontSize: ".875rem" },
    h6: { fontSize: "1.125rem", fontWeight: 600 }, body1: { fontSize: ".9375rem" }, body2: { fontSize: ".875rem" } },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { minHeight: 40, padding: "9px 16px", borderRadius: 8 }, outlined: { borderColor: "#d8e1e8" } } },
    MuiIconButton: { styleOverrides: { root: { borderRadius: 8 } } },
    MuiOutlinedInput: { styleOverrides: { root: { fontSize: ".875rem", background: "#fff", borderRadius: 8 }, notchedOutline: { borderColor: "#d8e1e8" } } },
    MuiInputLabel: { styleOverrides: { root: { fontSize: ".875rem" } } },
    MuiTab: { styleOverrides: { root: { textTransform: "none", fontSize: ".875rem", fontWeight: 500, minHeight: 46 } } },
    MuiTabs: { styleOverrides: { indicator: { height: 3, borderRadius: 3 } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 16, boxShadow: "0 24px 80px #112b4533" } } },
    MuiChip: { styleOverrides: { root: { borderRadius: 6, fontWeight: 500 } } },
    MuiTooltip: { styleOverrides: { tooltip: { fontSize: ".75rem", borderRadius: 6, backgroundColor: "#172b3a", padding: "8px 10px" } } },
  },
});
